import React from 'react';
import ReactDOM from 'react-dom';
import Home from './Home';
import ReactGA from 'react-ga'

ReactGA.initialize('UA-100034472-1');
ReactGA.pageview(window.location.pathname + window.location.search);
ReactDOM.render(<Home />, document.querySelector('#root'));